<template>
  <div>
    <vs-input
        v-validate="'required|min:3'"
        data-vv-validate-on="blur"
        name="email"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="User"
        v-model="email"
        class="w-full"/>
    <span class="text-danger text-sm">{{ errors.first('email') }}</span>

    <vs-input
        data-vv-validate-on="blur"
        v-validate="'required|min:6|max:15'"
        type="password"
        name="password"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        label-placeholder="Password"
        v-model="password"
        class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

    <div class="flex flex-wrap justify-between my-5">
        <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox>
        <!--<router-link to="/pages/forgot-password">Forgot Password?</router-link>-->
    </div>
    <div class="flex flex-wrap justify-between mb-3">
      <vs-button :disabled="!validateForm" @click="loginJWT">Login</vs-button>
    </div>
  </div>
</template>

<script>
import axios from "@/axios.js"
import store from "../../../store/store"
export default {
  data() {
    return {
      email: '',
      password: '',
      checkbox_remember_me: false
    }
  },
  created() {
    this.setFilters()
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email != '' && this.password != '';
    },
  },
  methods: {
    setFilters: function(){
      axios.get('/resources/dictionary.json?ver='+Math.random(1,9999999)).then(function(result){
        if(result.data!==undefined){
          localStorage.setItem('dictionary_en', JSON.stringify(result.data.en));
          localStorage.setItem('dictionary_ru', JSON.stringify(result.data.ru));
        }
      });
      let that = this;
      axios.get("/api/lists")
          .then((response) => {
                if(response.data.accounts!==undefined){
                  localStorage.setItem('accountsList', JSON.stringify(response.data.accounts));
                  localStorage.setItem('brokersList', JSON.stringify(response.data.brokers));
                  localStorage.setItem('agentList', JSON.stringify(response.data.agents));
                  localStorage.setItem('clientColumns', JSON.stringify(response.data.clientColumns));
                  localStorage.setItem('transactionsColumns', JSON.stringify(response.data.transactionsColumns));
                  localStorage.setItem('documentsColumns', JSON.stringify(response.data.documentsColumns));
                  localStorage.setItem('brokersColumns', JSON.stringify(response.data.brokersColumns));
                  localStorage.setItem('depositsColumns', JSON.stringify(response.data.depositsColumns));
                  localStorage.setItem('riskColumns', JSON.stringify(response.data.riskColumns));
                  localStorage.setItem('pickLists', JSON.stringify(response.data));  
                  localStorage.setItem('addressColumns', JSON.stringify(response.data.addressColumns));
                  localStorage.setItem('ticketColumns', JSON.stringify(response.data.ticketColumns));
                  localStorage.setItem('departmentList', JSON.stringify(response.data.departmentList));
                  
                  if(response.data.productsColumns){
                    localStorage.setItem('productsColumns', JSON.stringify(response.data.productsColumns));
                    localStorage.setItem('tokensColumns', JSON.stringify(response.data.tokensColumns));
                    localStorage.setItem('contractsColumns', JSON.stringify(response.data.contractsColumns));
                  }   
                  if(response.data.wireDetailsColumns){
                    localStorage.setItem('wireDetailsColumns', JSON.stringify(response.data.wireDetailsColumns));                    
                  }             
                  let fileTypes = [];
                  for(let i in response.data.docNames){
                    fileTypes.push(response.data.docNames[i].doc_name);
                  }
                  localStorage.setItem('docNamesList', JSON.stringify(fileTypes));
                  
                  /*
                  let departmentList = [];
                  for(let i in [response.data.departments]){
                    departmentList.push(JSON.parse(response.data.departments[i].object));
                  }
                  localStorage.setItem('departmentList', JSON.stringify(departmentList));
                    */
                  that.$store.commit('SET_LOCAL_STORAGE_DATA');
                }
            
          })
          .catch(() => {  })
    },
    checkLogin() {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {

        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
      return true
    },
    setColumns: function(columns){
      let client = [];
      let transactions = [];
      let documents = [];
      let brokers = [];
      let deposits = [];
      let wire = [];
      try{
        let clientColumns= JSON.parse(localStorage.getItem('clientColumns'));        
        for(let column in clientColumns){
            if(columns.client_section.includes(clientColumns[column].headerName))
              client.push(clientColumns[column]);
        }
      } catch(e){this.logError();}
      localStorage.setItem('clientColumns', JSON.stringify(client));

      try{
        let transactionsColumns= JSON.parse(localStorage.getItem('transactionsColumns'));      
        for(let column in transactionsColumns){
            if(columns.tran_section.includes(transactionsColumns[column].headerName))
              transactions.push(transactionsColumns[column]);
        }
      } catch(e){this.logError();}
      localStorage.setItem('transactionsColumns', JSON.stringify(transactions));

      try{
        let documentsColumns= JSON.parse(localStorage.getItem('documentsColumns'));      
        for(let column in documentsColumns){
            if(columns.doc_section.includes(documentsColumns[column].headerName))
              documents.push(documentsColumns[column]);
        }
      } catch(e){this.logError();}
      localStorage.setItem('documentsColumns', JSON.stringify(documents));

      try{
      let brokersColumns= JSON.parse(localStorage.getItem('brokersColumns'));      
      for(let column in brokersColumns){
          if(columns.broker_section.includes(brokersColumns[column].headerName))
            brokers.push(brokersColumns[column]);
      }
      } catch(e){this.logError();}
      localStorage.setItem('brokersColumns', JSON.stringify(brokers));
      
      try{
      let wireDetailsColumns= JSON.parse(localStorage.getItem('wireDetailsColumns'));      
      for(let column in wireDetailsColumns){
          if(columns.wire_detail_section.includes(wireDetailsColumns[column].headerName))
            wire.push(wireDetailsColumns[column]);
      }
      } catch(e){this.logError();}
      localStorage.setItem('wireDetailsColumns', JSON.stringify(wire));
      
      try{
        let depositsColumns= JSON.parse(localStorage.getItem('depositsColumns'));        
        for(let column in depositsColumns){
            if(columns.deposit_section.includes(depositsColumns[column].headerName))
              deposits.push(depositsColumns[column]);
        }
      } catch(e){ this.logError(); }
      localStorage.setItem('depositsColumns', JSON.stringify(deposits));
    },
    logError(){
      return false;
    },
    loginJWT() {
      //if (!this.checkLogin()) return
      // Loading
      let that = this;
      this.$vs.loading()
      const params = new URLSearchParams();
      params.append('pass', this.password);
      params.append('email', this.email);
      axios.post('/api/login', params)
        .then((response) => {
          if(response.data.success===false){
            that.$vs.notify({
              title: 'Error',
              text: response.data.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          } else{
            if(response.data.user!==undefined){
             
              localStorage.setItem("userInfo", JSON.stringify(response.data.user));
              response.data.sections.sort((a, b) => (a.order_num > b.order_num) ? 1 : -1)
              console.log(response.data.sections)
              localStorage.setItem("navMenu", JSON.stringify(response.data.sections));   
              store.commit("UPDATE_USER_INFO", response.data.user);
              console.log('success!')
              console.log(response.data.user)
              
              that.setColumns(response.data.user.columns);
            } else{
             
              location.reload();
            }
            that.$vs.notify({
              title: 'Good job!',
              text: '',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            })
            that.$router.push(response.data.page).catch(() => {})
          }
          that.$vs.loading.close() 
        })
        .catch(error => {
          that.$vs.loading.close()
          that.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  }
}

</script>

